import { render, staticRenderFns } from "./WalletListTable.vue?vue&type=template&id=1cdb5488&"
import script from "./WalletListTable.vue?vue&type=script&lang=js&"
export * from "./WalletListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports